export interface Country {
  code: string;
  name: string;
}

export interface Citizenship {
  code: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  { code: 'AF', name: 'Afghanistan' },
  { code: 'AL', name: 'Albania' },
  { code: 'DZ', name: 'Algeria' },
  { code: 'AD', name: 'Andorra' },
  { code: 'AO', name: 'Angola' },
  { code: 'AG', name: 'Antigua and Barbuda' },
  { code: 'AR', name: 'Argentina' },
  { code: 'AM', name: 'Armenia' },
  { code: 'AU', name: 'Australia' },
  { code: 'AT', name: 'Austria' },
  { code: 'AZ', name: 'Azerbaijan' },
  { code: 'BS', name: 'Bahamas' },
  { code: 'BH', name: 'Bahrain' },
  { code: 'BD', name: 'Bangladesh' },
  { code: 'BB', name: 'Barbados' },
  { code: 'BY', name: 'Belarus' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BZ', name: 'Belize' },
  { code: 'BJ', name: 'Benin' },
  { code: 'BT', name: 'Bhutan' },
  { code: 'BO', name: 'Bolivia' },
  { code: 'BA', name: 'Bosnia and Herzegovina' },
  { code: 'BW', name: 'Botswana' },
  { code: 'BR', name: 'Brazil' },
  { code: 'BN', name: 'Brunei' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'BF', name: 'Burkina Faso' },
  { code: 'BI', name: 'Burundi' },
  { code: 'CV', name: 'Cabo Verde' },
  { code: 'KH', name: 'Cambodia' },
  { code: 'CM', name: 'Cameroon' },
  { code: 'CA', name: 'Canada' },
  { code: 'CF', name: 'Central African Republic' },
  { code: 'TD', name: 'Chad' },
  { code: 'CL', name: 'Chile' },
  { code: 'CN', name: 'China' },
  { code: 'CO', name: 'Colombia' },
  { code: 'KM', name: 'Comoros' },
  { code: 'CG', name: 'Congo' },
  { code: 'CR', name: 'Costa Rica' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CU', name: 'Cuba' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'CD', name: 'Democratic Republic of the Congo' },
  { code: 'DK', name: 'Denmark' },
  { code: 'DJ', name: 'Djibouti' },
  { code: 'DM', name: 'Dominica' },
  { code: 'DO', name: 'Dominican Republic' },
  { code: 'EC', name: 'Ecuador' },
  { code: 'EG', name: 'Egypt' },
  { code: 'SV', name: 'El Salvador' },
  { code: 'GQ', name: 'Equatorial Guinea' },
  { code: 'ER', name: 'Eritrea' },
  { code: 'EE', name: 'Estonia' },
  { code: 'ET', name: 'Ethiopia' },
  { code: 'FJ', name: 'Fiji' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GA', name: 'Gabon' },
  { code: 'GM', name: 'Gambia' },
  { code: 'GE', name: 'Georgia' },
  { code: 'DE', name: 'Germany' },
  { code: 'GH', name: 'Ghana' },
  { code: 'GR', name: 'Greece' },
  { code: 'GD', name: 'Grenada' },
  { code: 'GT', name: 'Guatemala' },
  { code: 'GN', name: 'Guinea' },
  { code: 'GW', name: 'Guinea-Bissau' },
  { code: 'GY', name: 'Guyana' },
  { code: 'HT', name: 'Haiti' },
  { code: 'HN', name: 'Honduras' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IS', name: 'Iceland' },
  { code: 'IN', name: 'India' },
  { code: 'ID', name: 'Indonesia' },
  { code: 'IR', name: 'Iran' },
  { code: 'IQ', name: 'Iraq' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IL', name: 'Israel' },
  { code: 'IT', name: 'Italy' },
  { code: 'JM', name: 'Jamaica' },
  { code: 'JP', name: 'Japan' },
  { code: 'JO', name: 'Jordan' },
  { code: 'KZ', name: 'Kazakhstan' },
  { code: 'KE', name: 'Kenya' },
  { code: 'KI', name: 'Kiribati' },
  { code: 'KP', name: 'North Korea' },
  { code: 'KR', name: 'South Korea' },
  { code: 'KW', name: 'Kuwait' },
  { code: 'KG', name: 'Kyrgyzstan' },
  { code: 'LA', name: 'Laos' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LB', name: 'Lebanon' },
  { code: 'LS', name: 'Lesotho' },
  { code: 'LR', name: 'Liberia' },
  { code: 'LY', name: 'Libya' },
  { code: 'LI', name: 'Liechtenstein' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MG', name: 'Madagascar' },
  { code: 'MW', name: 'Malawi' },
  { code: 'MY', name: 'Malaysia' },
  { code: 'MV', name: 'Maldives' },
  { code: 'ML', name: 'Mali' },
  { code: 'MT', name: 'Malta' },
  { code: 'MH', name: 'Marshall Islands' },
  { code: 'MR', name: 'Mauritania' },
  { code: 'MU', name: 'Mauritius' },
  { code: 'MX', name: 'Mexico' },
  { code: 'FM', name: 'Micronesia' },
  { code: 'MD', name: 'Moldova' },
  { code: 'MC', name: 'Monaco' },
  { code: 'MN', name: 'Mongolia' },
  { code: 'ME', name: 'Montenegro' },
  { code: 'MA', name: 'Morocco' },
  { code: 'MZ', name: 'Mozambique' },
  { code: 'MM', name: 'Myanmar' },
  { code: 'NA', name: 'Namibia' },
  { code: 'NR', name: 'Nauru' },
  { code: 'NP', name: 'Nepal' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'NI', name: 'Nicaragua' },
  { code: 'NE', name: 'Niger' },
  { code: 'NG', name: 'Nigeria' },
  { code: 'MK', name: 'North Macedonia' },
  { code: 'NO', name: 'Norway' },
  { code: 'OM', name: 'Oman' },
  { code: 'PK', name: 'Pakistan' },
  { code: 'PW', name: 'Palau' },
  { code: 'PA', name: 'Panama' },
  { code: 'PG', name: 'Papua New Guinea' },
  { code: 'PY', name: 'Paraguay' },
  { code: 'PE', name: 'Peru' },
  { code: 'PH', name: 'Philippines' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'QA', name: 'Qatar' },
  { code: 'RO', name: 'Romania' },
  { code: 'RU', name: 'Russia' },
  { code: 'RW', name: 'Rwanda' },
  { code: 'KN', name: 'Saint Kitts and Nevis' },
  { code: 'LC', name: 'Saint Lucia' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: 'WS', name: 'Samoa' },
  { code: 'SM', name: 'San Marino' },
  { code: 'ST', name: 'Sao Tome and Principe' },
  { code: 'SA', name: 'Saudi Arabia' },
  { code: 'SN', name: 'Senegal' },
  { code: 'RS', name: 'Serbia' },
  { code: 'SC', name: 'Seychelles' },
  { code: 'SL', name: 'Sierra Leone' },
  { code: 'SG', name: 'Singapore' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'SB', name: 'Solomon Islands' },
  { code: 'SO', name: 'Somalia' },
  { code: 'ZA', name: 'South Africa' },
  { code: 'SS', name: 'South Sudan' },
  { code: 'ES', name: 'Spain' },
  { code: 'LK', name: 'Sri Lanka' },
  { code: 'SD', name: 'Sudan' },
  { code: 'SR', name: 'Suriname' },
  { code: 'SZ', name: 'Eswatini' },
  { code: 'SE', name: 'Sweden' },
  { code: 'CH', name: 'Switzerland' },
  { code: 'SY', name: 'Syria' },
  { code: 'TW', name: 'Taiwan' },
  { code: 'TJ', name: 'Tajikistan' },
  { code: 'TZ', name: 'Tanzania' },
  { code: 'TH', name: 'Thailand' },
  { code: 'TL', name: 'Timor-Leste' },
  { code: 'TG', name: 'Togo' },
  { code: 'TO', name: 'Tonga' },
  { code: 'TT', name: 'Trinidad and Tobago' },
  { code: 'TN', name: 'Tunisia' },
  { code: 'TR', name: 'Turkey' },
  { code: 'TM', name: 'Turkmenistan' },
  { code: 'TV', name: 'Tuvalu' },
  { code: 'UG', name: 'Uganda' },
  { code: 'UA', name: 'Ukraine' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'UY', name: 'Uruguay' },
  { code: 'UZ', name: 'Uzbekistan' },
  { code: 'VU', name: 'Vanuatu' },
  { code: 'VA', name: 'Vatican City' },
  { code: 'VE', name: 'Venezuela' },
  { code: 'VN', name: 'Vietnam' },
  { code: 'YE', name: 'Yemen' },
  { code: 'ZM', name: 'Zambia' },
  { code: 'ZW', name: 'Zimbabwe' }
];

export const CITIZENSHIPS: Citizenship[] = [
  { code: 'AF', name: 'Afghan' },
  { code: 'AL', name: 'Albanian' },
  { code: 'DZ', name: 'Algerian' },
  { code: 'AD', name: 'Andorran' },
  { code: 'AO', name: 'Angolan' },
  { code: 'AG', name: 'Antiguan' },
  { code: 'AR', name: 'Argentine' },
  { code: 'AM', name: 'Armenian' },
  { code: 'AU', name: 'Australian' },
  { code: 'AT', name: 'Austrian' },
  { code: 'AZ', name: 'Azerbaijani' },
  { code: 'BS', name: 'Bahamian' },
  { code: 'BH', name: 'Bahraini' },
  { code: 'BD', name: 'Bangladeshi' },
  { code: 'BB', name: 'Barbadian' },
  { code: 'BY', name: 'Belarusian' },
  { code: 'BE', name: 'Belgian' },
  { code: 'BZ', name: 'Belizean' },
  { code: 'BJ', name: 'Beninese' },
  { code: 'BT', name: 'Bhutanese' },
  { code: 'BO', name: 'Bolivian' },
  { code: 'BA', name: 'Bosnian' },
  { code: 'BW', name: 'Botswanan' },
  { code: 'BR', name: 'Brazilian' },
  { code: 'BN', name: 'Bruneian' },
  { code: 'BG', name: 'Bulgarian' },
  { code: 'BF', name: 'Burkinabe' },
  { code: 'BI', name: 'Burundian' },
  { code: 'CV', name: 'Cape Verdean' },
  { code: 'KH', name: 'Cambodian' },
  { code: 'CM', name: 'Cameroonian' },
  { code: 'CA', name: 'Canadian' },
  { code: 'CF', name: 'Central African' },
  { code: 'TD', name: 'Chadian' },
  { code: 'CL', name: 'Chilean' },
  { code: 'CN', name: 'Chinese' },
  { code: 'CO', name: 'Colombian' },
  { code: 'KM', name: 'Comorian' },
  { code: 'CG', name: 'Congolese' },
  { code: 'CR', name: 'Costa Rican' },
  { code: 'HR', name: 'Croatian' },
  { code: 'CU', name: 'Cuban' },
  { code: 'CY', name: 'Cypriot' },
  { code: 'CZ', name: 'Czech' },
  { code: 'CD', name: 'Congolese' },
  { code: 'DK', name: 'Danish' },
  { code: 'DJ', name: 'Djiboutian' },
  { code: 'DM', name: 'Dominican' },
  { code: 'DO', name: 'Dominican' },
  { code: 'EC', name: 'Ecuadorian' },
  { code: 'EG', name: 'Egyptian' },
  { code: 'SV', name: 'Salvadoran' },
  { code: 'GQ', name: 'Equatorial Guinean' },
  { code: 'ER', name: 'Eritrean' },
  { code: 'EE', name: 'Estonian' },
  { code: 'ET', name: 'Ethiopian' },
  { code: 'FJ', name: 'Fijian' },
  { code: 'FI', name: 'Finnish' },
  { code: 'FR', name: 'French' },
  { code: 'GA', name: 'Gabonese' },
  { code: 'GM', name: 'Gambian' },
  { code: 'GE', name: 'Georgian' },
  { code: 'DE', name: 'German' },
  { code: 'GH', name: 'Ghanaian' },
  { code: 'GR', name: 'Greek' },
  { code: 'GD', name: 'Grenadian' },
  { code: 'GT', name: 'Guatemalan' },
  { code: 'GN', name: 'Guinean' },
  { code: 'GW', name: 'Guinea-Bissauan' },
  { code: 'GY', name: 'Guyanese' },
  { code: 'HT', name: 'Haitian' },
  { code: 'HN', name: 'Honduran' },
  { code: 'HU', name: 'Hungarian' },
  { code: 'IS', name: 'Icelandic' },
  { code: 'IN', name: 'Indian' },
  { code: 'ID', name: 'Indonesian' },
  { code: 'IR', name: 'Iranian' },
  { code: 'IQ', name: 'Iraqi' },
  { code: 'IE', name: 'Irish' },
  { code: 'IL', name: 'Israeli' },
  { code: 'IT', name: 'Italian' },
  { code: 'JM', name: 'Jamaican' },
  { code: 'JP', name: 'Japanese' },
  { code: 'JO', name: 'Jordanian' },
  { code: 'KZ', name: 'Kazakh' },
  { code: 'KE', name: 'Kenyan' },
  { code: 'KI', name: 'I-Kiribati' },
  { code: 'KP', name: 'North Korean' },
  { code: 'KR', name: 'South Korean' },
  { code: 'KW', name: 'Kuwaiti' },
  { code: 'KG', name: 'Kyrgyz' },
  { code: 'LA', name: 'Laotian' },
  { code: 'LV', name: 'Latvian' },
  { code: 'LB', name: 'Lebanese' },
  { code: 'LS', name: 'Basotho' },
  { code: 'LR', name: 'Liberian' },
  { code: 'LY', name: 'Libyan' },
  { code: 'LI', name: 'Liechtensteiner' },
  { code: 'LT', name: 'Lithuanian' },
  { code: 'LU', name: 'Luxembourger' },
  { code: 'MG', name: 'Malagasy' },
  { code: 'MW', name: 'Malawian' },
  { code: 'MY', name: 'Malaysian' },
  { code: 'MV', name: 'Maldivian' },
  { code: 'ML', name: 'Malian' },
  { code: 'MT', name: 'Maltese' },
  { code: 'MH', name: 'Marshallese' },
  { code: 'MR', name: 'Mauritanian' },
  { code: 'MU', name: 'Mauritian' },
  { code: 'MX', name: 'Mexican' },
  { code: 'FM', name: 'Micronesian' },
  { code: 'MD', name: 'Moldovan' },
  { code: 'MC', name: 'Monacan' },
  { code: 'MN', name: 'Mongolian' },
  { code: 'ME', name: 'Montenegrin' },
  { code: 'MA', name: 'Moroccan' },
  { code: 'MZ', name: 'Mozambican' },
  { code: 'MM', name: 'Burmese' },
  { code: 'NA', name: 'Namibian' },
  { code: 'NR', name: 'Nauruan' },
  { code: 'NP', name: 'Nepalese' },
  { code: 'NL', name: 'Dutch' },
  { code: 'NZ', name: 'New Zealander' },
  { code: 'NI', name: 'Nicaraguan' },
  { code: 'NE', name: 'Nigerien' },
  { code: 'NG', name: 'Nigerian' },
  { code: 'MK', name: 'Macedonian' },
  { code: 'NO', name: 'Norwegian' },
  { code: 'OM', name: 'Omani' },
  { code: 'PK', name: 'Pakistani' },
  { code: 'PW', name: 'Palauan' },
  { code: 'PA', name: 'Panamanian' },
  { code: 'PG', name: 'Papua New Guinean' },
  { code: 'PY', name: 'Paraguayan' },
  { code: 'PE', name: 'Peruvian' },
  { code: 'PH', name: 'Filipino' },
  { code: 'PL', name: 'Polish' },
  { code: 'PT', name: 'Portuguese' },
  { code: 'QA', name: 'Qatari' },
  { code: 'RO', name: 'Romanian' },
  { code: 'RU', name: 'Russian' },
  { code: 'RW', name: 'Rwandan' },
  { code: 'KN', name: 'Kittitian' },
  { code: 'LC', name: 'Saint Lucian' },
  { code: 'VC', name: 'Vincentian' },
  { code: 'WS', name: 'Samoan' },
  { code: 'SM', name: 'Sammarinese' },
  { code: 'ST', name: 'Sao Tomean' },
  { code: 'SA', name: 'Saudi' },
  { code: 'SN', name: 'Senegalese' },
  { code: 'RS', name: 'Serbian' },
  { code: 'SC', name: 'Seychellois' },
  { code: 'SL', name: 'Sierra Leonean' },
  { code: 'SG', name: 'Singaporean' },
  { code: 'SK', name: 'Slovak' },
  { code: 'SI', name: 'Slovenian' },
  { code: 'SB', name: 'Solomon Islander' },
  { code: 'SO', name: 'Somali' },
  { code: 'ZA', name: 'South African' },
  { code: 'SS', name: 'South Sudanese' },
  { code: 'ES', name: 'Spanish' },
  { code: 'LK', name: 'Sri Lankan' },
  { code: 'SD', name: 'Sudanese' },
  { code: 'SR', name: 'Surinamese' },
  { code: 'SZ', name: 'Swazi' },
  { code: 'SE', name: 'Swedish' },
  { code: 'CH', name: 'Swiss' },
  { code: 'SY', name: 'Syrian' },
  { code: 'TW', name: 'Taiwanese' },
  { code: 'TJ', name: 'Tajik' },
  { code: 'TZ', name: 'Tanzanian' },
  { code: 'TH', name: 'Thai' },
  { code: 'TL', name: 'Timorese' },
  { code: 'TG', name: 'Togolese' },
  { code: 'TO', name: 'Tongan' },
  { code: 'TT', name: 'Trinidadian' },
  { code: 'TN', name: 'Tunisian' },
  { code: 'TR', name: 'Turkish' },
  { code: 'TM', name: 'Turkmen' },
  { code: 'TV', name: 'Tuvaluan' },
  { code: 'UG', name: 'Ugandan' },
  { code: 'UA', name: 'Ukrainian' },
  { code: 'AE', name: 'Emirati' },
  { code: 'GB', name: 'British' },
  { code: 'US', name: 'American' },
  { code: 'UY', name: 'Uruguayan' },
  { code: 'UZ', name: 'Uzbek' },
  { code: 'VU', name: 'Ni-Vanuatu' },
  { code: 'VA', name: 'Vatican' },
  { code: 'VE', name: 'Venezuelan' },
  { code: 'VN', name: 'Vietnamese' },
  { code: 'YE', name: 'Yemeni' },
  { code: 'ZM', name: 'Zambian' },
  { code: 'ZW', name: 'Zimbabwean' }
];

